export default __webpack_public_path__ + "static/media/twitter-1476523798946107397.b8f1649c.jpg";